import axios from 'axios';
import { apiClient, API_ENDPOINTS } from './client';
import { CurrentUserResponse } from '@/types/user';

export async function fetchCurrentUser(apiBaseUrl?: string): Promise<CurrentUserResponse> {
  const endpoint = API_ENDPOINTS.user.getCurrentUser;
  
  // Determine the base URL and remove v4 for currentuser endpoint
  let baseUrl = apiBaseUrl || apiClient.defaults.baseURL as string;
  
  // Remove /v4 from the base URL for currentuser endpoint
  baseUrl = baseUrl.replace(/\/v4$/, '');
  
  const customClient = axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      ...apiClient.defaults.headers.common,
    },
  });
  
  if (baseUrl.includes('ngrok')) {
    customClient.defaults.headers['ngrok-skip-browser-warning'] = 'true';
  }
  
  const response = await customClient.get<CurrentUserResponse>(endpoint);
  return response.data;
}
